import { GenericControl } from "../../UI.BaseControls/GenericControl";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { CalendarCell } from "./CalendarCell";
import { CalendarEventItem, CalendarEventItemType } from "./CalendarEventItem";

export class DayHourCell extends CalendarCell {
    private _topElement: HTMLElement;
    private _dayNameElement: HTMLSpanElement;
    private _dayNumberElement: HTMLSpanElement;

    public set dayNameText(v: string) {
        this._dayNameElement.textContent = v;
    }

    public get dayNameText(): string {
        return this._dayNameElement.textContent;
    }

    public set dayNumberText(v: string) {
        this._dayNumberElement.textContent = v;
    }

    public get dayNumberText(): string {
        return this._dayNumberElement.textContent;
    }

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected override _constructor(): void {
        GenericControl._constructor(this as HTMLElement);

        this._dayNameElement = createElement({ type: "span", classes: "day-name" }) as HTMLSpanElement;
        this._dayNumberElement = createElement({ type: "span", classes: "day-number" }) as HTMLSpanElement;
        this._topElement = createElement({ classes: "top" });
        this._eventElement = createElement({ classes: "bottom event-content" });

        this.classList.add("hour-cell");

        this._topElement.appendChild(this._dayNameElement);
        this._topElement.appendChild(this._dayNumberElement);
        this._topElement.style.display = "none";
        this.appendChild(this._topElement);
        this.appendChild(this._eventElement);
    }

    public get hourId(): string {
        return `${this.idOfCell.getHours()}|${this.idOfCell.getDate()}|${this.idOfCell.getMonth()}|${this.idOfCell.getFullYear()}`;
    } // `

    public set allDayCell(isAllday: boolean) {
        if (isAllday) {
            this._eventElement.classList.add("allday-row");
        } else
            this._eventElement.classList.remove("allday-row");
    }

    public set visibleDayNumber(visible: boolean) {
        if (visible) {
            this._topElement.style.display = "";
            this.classList.toggle("today", this.isToday);
        } else
            this._topElement.style.display = "none";
    }

    protected override async _updateStyles(): Promise<void> {
        this.classList.toggle("weekend", this.isWeekend);
    }

    /**
     * Vrátí pozici elementu v rámci dokumentu
     */
    public offset(): { top: number; left: number; width: number; height: number } {
        return GenericControl.offset(this as HTMLElement);
    }

    protected override _addStandaloneEvent(cei: CalendarEventItem): void {
        const items = this.eventItems;
        for (const item of items) {
            if (item.type == CalendarEventItemType.standalone && item.parentEvent.dateFrom > cei.parentEvent.dateFrom) {
                item.insertAdjacentElement("beforebegin", cei);
                return;
            }

            if (item.isEmpty) {
                item.insertAdjacentElement("beforebegin", cei);
                item.remove();
                return;
            }
        }
        this._eventElement.insertAdjacentElement("beforeend", cei);
    }
    //#enregion Zpracování metod z globální třídy GenericControl
}

registerCustomElement("tsc-calendargriddaydaycell", DayHourCell);
